module.exports = {
   HierarchicalClustering: require("./hcluster").HierarchicalClustering,
   hcluster: require("./hcluster").hcluster,
   leaves: require("./hcluster").leaves,
   Kmeans: require("./kmeans"),
   kmeans: require("./kmeans").kmeans
};